import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const digitalmarketing = {
    namespaced: true,
    state: {
      newsLetterSubscriptions: [],
    },
    getters: {
      getNewsLetterSubscriptions (state) {
        return state.newsLetterSubscriptions;
      },
    },
    mutations: {
      setNewsLetterSubscriptions (state, data) {
        state.newsLetterSubscriptions = data;
      },
    },
    actions: {
      async fetchNewsLetterSubscriptions ({ dispatch, commit }, payload) {
        const url = `/app-modules/${payload.appModuleName}/newsletter-mail-ids`;
        try {
          const response = await axios.get(url);
          commit('setNewsLetterSubscriptions', response.data);
        } catch (exception) {
            dispatch('alert/onAlert', {
              message: 'Something went wrong in getting newsletter subscriptions list.',
              type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
    },
};
